export interface MeaningItem {
  title: string;
  summary: string;
  badge: string;
}

export const decodeItems: MeaningItem[] = [
  {
    badge: "拆字",
    title: "吃瓜 = 围观、看热闹",
    summary: "「吃瓜」是网络语境里“围观八卦、坐等更新”的说法，来自“吃瓜群众”。先有瓜，才有吃瓜的人。",
  },
  {
    badge: "数字",
    title: "9 ≈ 就 / 谐音联读",
    summary: "在数字谐音里，9 常被念作“就”或“久”，为后面连读提供了天然的联想空间，也像在等“第 9 手消息”。",
  },
  {
    badge: "数字",
    title: "1 ≈ 要 / 一个开场",
    summary: "1 念作“要”也说得通，连起来近似“吃瓜就要……”，像一句话被人截断后的半句，留着让人追问。",
  },
];

export const decodeGrid: MeaningItem[] = [
  {
    badge: "联读",
    title: "「91」像一句没说完的话",
    summary: "读成“就要 / 久一”，就像有人抢着表态“吃瓜就位、坐等前排”，语气里有种急吼吼的参与感。",
  },
  {
    badge: "指代",
    title: "也可能指向某个“瓜棚”编号",
    summary: "部分网友把 91 当成某个吃瓜阵地或话题分区的门牌号，见到“吃瓜91”等于通知你“那边有戏、快去”。",
  },
  {
    badge: "梗",
    title: "本质是数字梗的“在场暗号”",
    summary: "比起精确解释，它更像一句暗号：发出来不是要答案，而是要拉你一起进入围观同一场热闹的状态。",
  },
];

export interface CompareRow {
  claim: string;
  sideA: string;
  sideB: string;
  take: string;
}

export const compareRows: CompareRow[] = [
  {
    claim: "含义中心",
    sideA: "“围观八卦”本体",
    sideB: "“邀你一起看”的动作",
    take: "无论偏哪个，落点都是“进入吃瓜现场”，差别只在语气。",
  },
  {
    claim: "91 的来路",
    sideA: "谐音派：就要 / 就一",
    sideB: "编号派：门牌 / 分区号",
    take: "谐音图顺口，编号图方便指代，两者都有人在用。",
  },
  {
    claim: "使用场景",
    sideA: "玩笑、熟人闲聊",
    sideB: "弹幕、评论区接头",
    take: "多为轻松场合，正式表达里基本不会出现这个词。",
  },
];

export interface OriginItem {
  no: string;
  title: string;
  summary: string;
  tag: string;
}

export const originItems: OriginItem[] = [
  {
    no: "说一",
    title: "从“谐音造句”发散出来的",
    summary: "最初更像某条评论或弹幕里的一句顺口表达，“吃瓜+数字”凑在一起成了被截图传播的段子，越传越广。",
    tag: "流传较广",
  },
  {
    no: "说二",
    title: "数字代表“第几手 / 排队序号”",
    summary: "有人把它理解成吃瓜现场的排队号——9 手料、1 号位，用来调侃信息在层层转述里“越传越玄”。",
    tag: "网友脑补",
  },
  {
    no: "说三",
    title: "先有画面感、后有解释",
    summary: "比起一个准确出处，更多人是因为“看到就懂那种凑热闹的心情”，才愿意跟着用，属于典型的玩梗式传播。",
    tag: "氛围共识",
  },
];

export interface UseItem {
  title: string;
  summary: string;
  k: string;
}

export const useList: UseItem[] = [
  {
    k: "接头",
    title: "有人发来“吃瓜91”？",
    summary: "把它当成“这里有瓜，速来”的邀约，回一个“来了来了，坐前排”就好，不用真的去考据出处。",
  },
  {
    k: "接梗",
    title: "不知道怎么回，怎么不冷场",
    summary: "顺着动作回：“后排都挤满了，给我留个前排”，对方一听就知道你在陪他一起围观。",
  },
  {
    k: "造句",
    title: "想主动甩这个数字梗",
    summary: "在大家都聊得热的时候发，配一句“吃瓜91，前排已就位”，重点是氛围到位，别硬凹。",
  },
  {
    k: "别用",
    title: "什么场合别乱用",
    summary: "正式聊天、工作对接里别用，容易显得突兀；吃瓜这个梗本身轻松，接错了反而比不接更尴尬。",
  },
];

export interface QuickItem {
  title: string;
  brief: string;
}

export const quickList: QuickItem[] = [
  { title: "吃瓜", brief: "围观八卦、看热闹，网络高频动词。" },
  { title: "前排", brief: "现场最前排位置，离“瓜”最近。" },
  { title: "猹", brief: "鲁迅《故乡》梗，指在瓜田里到处跑的围观者。" },
  { title: "来了来了", brief: "进场信号，宣布“我也加入围观”。" },
  { title: "蹲一个", brief: "守着等后续更新，常在评论区刷屏。" },
  { title: "已就位", brief: "表示备好状态，等瓜落地的准备动作。" },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "吃瓜91 是什么意思？",
    a: "可以粗浅地理解为“围观八卦、坐等吃瓜”的数字梗表达，后缀 91 常被谐音成“就要 / 就一”，整体像是在喊“吃瓜已就位，大家快来看”。",
  },
  {
    q: "91 是密码吗？",
    a: "严格说不算固定密码，更像一种谐音+数字梗的联想。数字在中文语境里常被拿来谐音造句，91 读作“就要”让整句有了“准备开吃”的动感。",
  },
  {
    q: "这个词的由来有定论吗？",
    a: "没有统一出处，属于网友玩出来的梗，围绕“谐音”“排队序号”“氛围默契”有多种说法，你选觉得顺的那种去理解即可。",
  },
  {
    q: "别人发这个数字给我，我该怎么回？",
    a: "直接接氛围：回一句“前排已就位 / 等瓜”，或在问清楚“哪儿有瓜”之前先表个“我跟上了”的态度，一般不会出错。",
  },
];